module.exports = __webpack_public_path__ + "img/metalMaterialsScience_sign.705b8096.png";